import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ExampleURLMaps } from './exampleURLMaps';
import { ExamplePopup } from './examplePopup';
import { EnvPropTypes } from '../../propTypes/genericPropTypes';

export const ExamplePopupTrigger = ({ exampleKey, env = 'prod' }) => {
  const [isExampleShowing, setIsExampleShowing] = useState(false);

  const {
    screenReader: { label: srLabel }
  } = ExampleURLMaps[exampleKey];

  const HandleExampleClose = () => {
    setIsExampleShowing(false);
  };

  const HandleExampleOpen = () => {
    setIsExampleShowing(true);
  };

  return (
    <div className="examplePopupWrapper">
      <button
        onClick={() => HandleExampleOpen()}
        type="button"
        className="button primary text_only"
      >
        <span className="labelText">
          See an example
          <span className="sr-only">{srLabel}</span>
        </span>
      </button>

      {isExampleShowing && (
        <ExamplePopup
          env={env}
          example={ExampleURLMaps[exampleKey]}
          onClose={HandleExampleClose}
        />
      )}
    </div>
  );
};

ExamplePopupTrigger.propTypes = {
  exampleKey: PropTypes.string,
  env: EnvPropTypes
};
